import { BarChartLabelProps } from 'components/BarChart/BarChartLabel';

export const getYMax = (data: BarChartLabelProps[]) => {
  const maxValues = data.map((item) => {
    let value: number;
    if (Array.isArray(item.value)) {
      value = Math.max(...item.value);
    } else {
      value = item.value as number;
    }
    if (value > 0 && value <= 1) {
      value = value * 100;
    }
    return value;
  });
  const maxValue = Math.max(...maxValues);
  const yMax = Math.round((maxValue + 20) / 10) * 10;
  return yMax < 100 ? yMax : 100;
};
